import React, { Component } from 'react';
import loader from './svgs/loader.svg';
import './index.css';

/**
 * Component for waiting for state to be loaded, showing a loader until then.
 *
 * @extends React.Component
 */
class WaitForState extends Component {
  /** @inheritdoc */
  render() {
    var keys = this.props.keys;
    if (keys === undefined) {
      keys = Object.keys(this.props.state);
    }
    var loaded = true;
    keys.forEach((key) => {
      if (!this.props.state[key]) {
        loaded = false;
      }
    });

    if (!loaded) {
      return (
        <div className="loader-container"><img className="loader" src={loader} alt="Indlæser" /></div>
      );
    }

    return this.props.children || null;
  }
}

export default WaitForState;



// WEBPACK FOOTER //
// ./src/components/WaitForState/index.js